import * as React from 'react'

import { Input } from '../atoms/Input'
import BaseField, { type Props as FieldProps } from './BaseField'

export type Props = FieldProps & {
  type?: 'text' | 'email' | 'password' | 'url'
  inputId?: string | null | undefined
  useEvent?: boolean
  isOfficeUse?: boolean
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
    onChange?: (event: string | React.ChangeEvent<HTMLInputElement>) => void
  }

const TextField: React.ComponentType<Props> = React.forwardRef(
  (props: Props, ref) => {
    const { hasError, type, value, inputId, smallLabel, errorLabel, ...rest } =
      props

    return (
      <BaseField
        {...rest}
        semibold
        errorLabel={errorLabel}
        hasError={hasError}
        smallLabel={smallLabel}
      >
        <Input
          {...rest}
          hasError={hasError}
          inputId={inputId}
          ref={ref as React.Ref<HTMLInputElement>}
          type={type ?? 'text'}
          value={value as string}
        />
      </BaseField>
    )
  }
)

export default TextField
